export default __webpack_public_path__ + "static/media/14-1_clone.fa6224a8.svg";